import "../styles/story.css";
// import storyImage from '../../images/tubbees-logo_small.png'


export default function Twentyone() {
  return (
    <div className="containerStory">
      <div className="storyHeading">
        <h2>2021</h2>
        {/* <img src={storyImage} alt="Tubbees brand expansion"/> */}
      </div>
      <p>We expanded, opening 3 new stores: Strathclyde, Scotstoun &amp; Crowwood.<br/><span>With up to 96 flavours at Strathclyde.</span></p>
    </div>
  );
}
